export const MESSAGE_DIRECTION = Object.freeze({
  RECEIVED: 'received',
  SENT: 'sent'
})
